import get from 'lodash/get';
/** import third-party libraries in the section above, Sort Lines Ascending */

/** import single application imports in the section above, Sort Lines Ascending */

export default function selector(storeState) {
    const profile = get(storeState, 'profile', {});
    return { profile };
}
